import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import styled from "styled-components";
import { ParagraphTextColor } from "utils";
// Routes
import { routes } from "routes/Dashboard";

import "./styles.scss";
const Container = styled.div`
  background-color: ${(props) => props.theme.dashboard.sidebar.background};
  color: ${(props) => props.theme.dashboard.sidebar.color};
  p {
    color: ${(props) => props.theme.dashboard.sidebar.color};
  }
  .sidebar__item {
    &:hover {
      background-color: ${(props) =>
        props.theme.dashboard.sidebar.items.hover.background};
    }
  }
  .sidebar__item__active {
    background-color: ${(props) =>
      props.theme.dashboard.sidebar.items.hover.background};
  }
`;
export const SidebarDashboard = () => {
  const history = useHistory();
  const { pathname } = useLocation();
  const { role } = JSON.parse(localStorage.getItem("userInfo")) || {};
  const renderRoutes = () => {
    var copyRoutes = [...routes];

    if (role === "sucursalWorker") {
      copyRoutes = copyRoutes.filter((route) => route.onlyAdmin === false);
    }

    return copyRoutes
      .filter((route) => route.sidebar)
      .map((route, index) => {
        return (
          <div
            className={`sidebar__item ${
              pathname.split("/").filter((item) => item !== "")[1] ==
              route.path.split("/").filter((item) => item !== "")[1]
                ? "sidebar__item__active"
                : ""
            }`}
            key={index}
            onClick={() => history.push(route.pathWithoutParams)}
          >
            <div className="sidebar__item__icon">{route.icon}</div>
            <ParagraphTextColor>{route.label}</ParagraphTextColor>
          </div>
        );
      });
  };
  return <Container className="sidebar__dashboard">{renderRoutes()}</Container>;
};
